const TreeView = (paths: string[][]) => {
  let result: any[] = [];
  let level = { result };

  paths.forEach((path) => {
    path[0].split("/").reduce((r: any, name) => {
      if (!r[name]) {
        r[name] = { result: [] };
        r.result.push({
          name,
          children: r[name].result,
          id: path[1]
        });
      }

      return r[name];
    }, level);
  });

  return result;
};

export default TreeView;